var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnhappyFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 285.53,
    y1: 193.61,
    x2: 1790.8,
    y2: 1889.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7ae30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1035.01,
    y1: 1034.97,
    x2: 1712.01,
    y2: 1700.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca4f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4901f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 335.77,
    y1: 325.21,
    x2: 811.75,
    y2: 808.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffca4f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 559.18,
    y1: 561.99,
    x2: 804.52,
    y2: 802.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7ae30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffca4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1222.06,
    y1: 546.93,
    x2: 1480.45,
    y2: 813.16,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1014.88,
    y1: 1275.03,
    x2: 1014.88,
    y2: 1678.4,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 593.41,
    y1: 595.49,
    x2: 768.74,
    y2: 767.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1258.75,
    y1: 584.73,
    x2: 1443.41,
    y2: 774.99,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1014.88,
    y1: 1212.86,
    x2: 1014.88,
    y2: 1515.4,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 231.46,
    y1: 49.86,
    x2: 231.46,
    y2: 508.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c8eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00cfe9"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1014.88,2000c-543.06,0-984.86-441.81-984.86-984.86S471.82,30.28,1014.88,30.28s984.86,441.81,984.86,984.86-441.81,984.86-984.86,984.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.8,1711.22c178.33,178.33,424.55,288.78,696.08,288.78,543.06,0,984.86-441.81,984.86-984.86,0-271.53-110.45-517.74-288.78-696.08L318.8,1711.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M567.21,1462.8c0-493.68,401.65-895.33,895.33-895.33,131.14,0,255.4,29.04,367.75,79.92C1689.63,336.8,1377.41,119.81,1014.88,119.81c-493.68,0-895.33,401.65-895.33,895.33,0,362.54,216.99,674.75,527.58,815.41-50.88-112.35-79.92-236.61-79.92-367.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M679.13,836.07c-86.39,0-156.68-70.3-156.68-156.68s70.3-156.68,156.68-156.68,156.68,70.3,156.68,156.68-70.3,156.68-156.68,156.68Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1350.62,836.07c-86.39,0-156.68-70.3-156.68-156.68s70.3-156.68,156.68-156.68,156.68,70.3,156.68,156.68-70.3,156.68-156.68,156.68Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M567.21,1552.36c-19.54,0-38.12-6.21-53.77-17.99-19.06-14.27-31.48-35.21-34.89-58.91-3.37-23.69,2.67-47.28,17.05-66.41,6.56-8.74,165.21-214.85,519.27-214.85s512.72,206.1,519.27,214.87c14.38,19.1,20.42,42.69,17.05,66.38-3.41,23.69-15.83,44.64-34.97,59-15.52,11.67-34.1,17.88-53.64,17.88-28.07,0-54.87-13.38-71.65-35.8-4.15-5.4-113.53-143.26-376.06-143.26s-371.81,137.84-376.41,143.7c-16.39,21.97-43.19,35.39-71.26,35.39Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 679.13,
    cy: 679.39,
    r: 111.92
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1350.62,
    cy: 679.39,
    r: 111.92
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1462.58,1507.57c-13.64,0-27.06-6.19-35.85-17.9-4.94-6.4-126.91-161.16-411.86-161.16s-410.64,159.55-411.86,161.16c-14.78,19.78-42.84,23.85-62.65,8.94-19.8-14.82-23.83-42.89-8.96-62.67,6.03-8.04,151.52-196.97,483.47-196.97s477.44,188.92,483.47,196.97c14.86,19.78,10.84,47.85-8.96,62.67-8.04,6.05-17.44,8.96-26.8,8.96Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.01,331.21c0,105.76,90.19,191.5,201.45,191.5,111.26,0,201.45-85.74,201.45-191.5,0-105.76-201.45-300.93-201.45-300.93,0,0-201.45,195.17-201.45,300.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhappyFace);
export default __webpack_public_path__ + "static/media/Unhappy Face.544e3948b3d50a18fbd33d87966516ec.svg";
export { ForwardRef as ReactComponent };